<!--
  header.component.html
  ---------------------
  Top bar layout:
    - CVX logo centred horizontally
    - Application name centred below the logo
    - User name pinned to top-right corner
-->
<header class="app-header">

  <!-- Centre: logo stacked above title -->
  <div class="app-header__brand">
    <img class="app-header__logo" src="CVX_Logo.png" alt="Chevron" />
    <span class="app-header__title">automated guardrail assessment tool</span>
  </div>

  <!-- Top-right: signed-in user name -->
  <div class="app-header__user">
    <span class="app-header__user-name">{{ displayName }}</span>
  </div>

</header>
